import { render } from "./statistic.vue?vue&type=template&id=524bc7de&scoped=true"
import script from "./statistic.vue?vue&type=script&lang=js"
export * from "./statistic.vue?vue&type=script&lang=js"

import "./statistic.vue?vue&type=style&index=0&id=524bc7de&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524bc7de"]])

export default __exports__